import styled from 'styled-components'

export const DraggerUploadStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .anticon {
    font-size: 24px;
  }
`

export const FormActionFooter = styled.div`
  display: flex;
  align-items: center;
  position: sticky;
  bottom: 0;
  z-index: 20;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-top: 1px solid #ebebeb;
  background-color: #fff;
  padding: 16px;
`

export const TableFooterActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 0;
`

export const FormElementWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  margin-bottom: 20px;
  div.left-content-wrapper {
    flex: 1;
    border-radius: 16px;
    background: #f7f7f7;
    padding: 20px;
    h3 {
      margin-bottom: 16px;
      font-size: 18px;
      font-weight: 600;
    }
    & .left-content {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 0 16px;

      .authority-issued-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        .custom-ant-button {
          width: 40px;
          height: 40px;
          margin-top: 30px;
        }
      }
    }
  }
  div.right-content-wrapper {
    height: fit-content;
    width: 372px;
    border-radius: 16px;
    background: #f7f7f7;
    padding: 20px;
    h3 {
      margin-bottom: 16px;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .item-span-2 {
    grid-column: span 2 / span 2;
  }
`
